import { TextFit, TextFitProps } from "./TextFit";

export { TextFit, TextFitProps };
